import { useMemo } from 'react';

import { useFindLocations } from '@/sections/region/hooks/useFindLocations';

interface Address {
  region?: string;
  commune?: string;
}

export const useRegionAndCommune = (address: Address) => {
  const { region, commune } = address ?? {};
  const { findRegionName, findCommuneName } = useFindLocations();

  const regionAndCommune = useMemo(() => {
    if (!region) return { region: '', commune: '' };
    const regionName = findRegionName(Number(region));
    const communeName = commune ? findCommuneName(Number(region), commune) : '';
    return { region: regionName, commune: communeName };
  }, [region, commune, findRegionName, findCommuneName]);

  return regionAndCommune;
};
